import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';
import {
  downloadFileDto,
  GetCustomerFileListDto,
} from 'src/app/data/dtos/access-file/access-file.dto';
import { RefreshTokenDto } from 'src/app/data/dtos/auth/auth.dto';
import {
  GetDistrictRequestDto,
  GetDistrictResponseDto,
  GetHousingTypeResponseDto,
  GetOccupationGroupResponseDto,
  GetOccupationRequestDto,
  GetOccupationResponseDto,
  GetPostCodeResponseDto,
  GetProvinceResponseDto,
  GetSubDistrictRequestDto,
  GetSubDistrictResponseDto,
} from 'src/app/data/dtos/data-dict/data-dict.dto';
import {
  NdidCheckRequestResponseDto,
  NdidRequestDataResponseDto,
} from 'src/app/data/dtos/ndid/ndid.dto';
import {
  GetAddressResponseDto,
  UpdateAddressRequestDto,
  updateTypeAddressRequestDto,
} from 'src/app/data/dtos/onboarding/address.dto';
import { GetAutoApproveResponse } from 'src/app/data/dtos/onboarding/auto-approve.dto';
import { VerifyIdCardNumberRequestDto } from 'src/app/data/dtos/onboarding/bulk.dto';
import {
  confirmDataRequestDto,
  confirmDataResponseDto,
} from 'src/app/data/dtos/onboarding/confirm-data.dto';
import {
  ConfirmOTPRequestDto,
  ContactRequestDto,
  SendOTPRequestDto,
} from 'src/app/data/dtos/onboarding/contact.dto';
import {
  DeleteDocumentRequestDto,
  UploadDocumentRequestDto,
  UploadOcrDocumentRequestDto,
  UploadSelfieRequestDto,
} from 'src/app/data/dtos/onboarding/document-source.dto';
import { GetLoanTypeListResponseDto } from 'src/app/data/dtos/onboarding/loan-type.dto';
import {
  PersonalInfoUpdateRequestDto,
  PersonalInfoUpdateResponseDto,
} from 'src/app/data/dtos/onboarding/personal-info.dto';
import { GetPersonalLoanResponseDto } from 'src/app/data/dtos/onboarding/personal-loan.dto';
import {
  confirmPersonalLoanRequestDto,
  confirmProductRequestDto,
  getProductlistRequestDto,
  getProductlistResponseDto,
  GetProductResponseDto,
  setLoanTypeRequestDto,
  setProductRequestDto,
} from 'src/app/data/dtos/onboarding/product.dto';
import { getResumeStateResponseDto } from 'src/app/data/dtos/onboarding/resume.dto';
import {
  StartKYCRequestDto,
  StartKYCResponseDto,
} from 'src/app/data/dtos/onboarding/start-kyc.dto';
import {
  getCurrentStateResponseDto,
  UpdateCurrentStepRequestDto,
} from 'src/app/data/dtos/onboarding/state.dto';
import {
  AcceptTermAndConsentRequestDto,
  AcceptTermAndConsentResponseDto,
  GetTermAndConsentRequestDto,
  GetTermAndConsentResponseDto,
} from 'src/app/data/dtos/onboarding/term-consent.dto';
import {
  BeginTransactionRequestDto,
  BeginTransactionResponseDto,
  CheckLimitPolicyResponse,
  CloseKycResponseDto,
  CompareUserDataResponseDto,
  GetDocumentResponseDto,
  GetProductRequestDto,
  GetSelfieResponseDto,
  GetTxnResponseDto,
  OnBoardingTransactionRequestDto,
  UpdateDocumentRequestDto,
} from 'src/app/data/dtos/onboarding/transaction.dto';
import { LoanInfoResponseDto } from 'src/app/data/dtos/onboarding/user-info.dto';
import {
  UpdateWorkingRequestDto,
  WorkingResponseDto,
} from 'src/app/data/dtos/onboarding/working.dto';
import { ResponseDto } from 'src/app/data/dtos/response.dto';
import { StarMoneyAdapterService } from '../services/star-money-adapter.service';
export enum Config {
  // get term and condition
  GET_TERM_AND_CONDITION = '/term-condition',
}

@Injectable()
export class ApiStarMoneyAdapterService extends StarMoneyAdapterService {
  constructor(private http: HttpClient) {
    super();
  }

  override saveCameraLog(request: any): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      'https://middleware.e-kyc.digital/logs/camera-logs',
      request,
      {
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': environment.api_key_camera_log,
        },
      }
    );
  }

  override signInAnonymous(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/auth/signin/anonymous',
      request
    );
  }

  override refreshToken(
    request: RefreshTokenDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/auth/refresh-token',
      request
    );
  }

  override getWorkFlow(): Observable<ResponseDto<any>> {
    // /v1/onboarding/workflow/get-workflow
    const now = new Date();
    const response: ResponseDto<any> = {
      statusCode: 200,
      timestamp: now.toISOString(),
      message: 'Success',
      data: {
        steps: [
          {
            step: 'root',
            state: 'Main',
            pages: [{ step: 'root', page_id: 19 }],
          },
          {
            step: 'resume',
            state: 'Resume',
            pages: [
              { page_id: 35 },
              { page_id: 7 },
              { page_id: 13, params: { type: 'confirm_otp' } },
              { page_id: 23 },
              { page_id: 10 },
            ],
          },
          {
            step: '0',
            state: 'Landing',
            pages: [
              { step: '0', page_id: 3 },
              { step: '0', page_id: 33 },
              { step: '0', page_id: 36 },
              { step: '0', page_id: 32 },
            ],
          },
          {
            step: '1',
            state: 'Select-Product',
            pages: [
              {
                step: '1.1',
                page_id: 1,
                can_resume: false,
                params: { code: 'terms_and_conditions' },
              },
              { step: '1.2', page_id: 20 },
            ],
          },
          {
            step: '2',
            state: 'Contact-Info',
            pages: [
              { step: '2.1', page_id: 7 },
              { step: '2.1', page_id: 13, params: { type: 'confirm_otp' } },
              { step: '2.2', page_id: 15 },
              { step: '2.2', page_id: 16 },
              {
                step: '2.3',
                page_id: 2,
                params: { code: 'consent_personal_data' },
              },
            ],
          },
          {
            step: '3',
            state: 'EKYC',
            pages: [
              {
                step: '3.1',
                page_id: 1,
                can_resume: false,
                params: { code: 'bio_terms_and_conditions' },
              },
              {
                step: '3.2',
                page_id: 6,
                sub_flows: [
                  {
                    step: '3.2.1',
                    state: 'id-card-front',
                    pages: [
                      { step: '3.2', page_id: 4 },
                      { step: '3.2', page_id: 17 },
                      { step: '3.2', page_id: 21 },
                      { step: '3.2', page_id: 23 },
                      { step: '3.2', page_id: 5 },
                    ],
                  },
                  {
                    step: '3.2.2',
                    state: 'id-card-back',
                    pages: [
                      { step: '3.2', page_id: 4 },
                      { step: '3.2', page_id: 17 },
                      { step: '3.2', page_id: 38 },
                      { step: '3.2', page_id: 5 },
                      { step: '3.2', page_id: 23 },
                    ],
                  },
                ],
              },
              {
                page_id: 12,
                step: '3.3',
                sub_flows: [
                  {
                    step: '3.3.1',
                    pages: [
                      { step: '3.3', page_id: 8 },
                      { step: '3.3', page_id: 17 },
                      { step: '3.3', page_id: 22 },
                      { step: '3.3', page_id: 23 },
                      { step: '3.3', page_id: 5 },
                    ],
                    state: 'face',
                    setting: {},
                  },
                ],
              },
            ],
          },
          {
            step: '4',
            state: 'Loan-Info',
            pages: [
              { step: '4.1', page_id: 27 },
              { step: '4.1', page_id: 28 },
              { step: '4.1', page_id: 29 },
              { step: '4.1', page_id: 30 },
              { step: '4.1', page_id: 24 },
            ],
          },
          {
            step: '5',
            state: 'NDID',
            pages: [
              {
                step: '5.1',
                page_id: 1,
                can_resume: false,
                params: {
                  code: 'consent_disclosure_info_via_internet',
                },
              },
              {
                step: '5.2',
                page_id: 1,
                params: { code: 'dopa_terms_and_conditions' },
              },
              {
                step: '5.3',
                page_id: 13,
                params: { type: 'confirm_otp_ncb' },
              },
              {
                step: '5.3',
                page_id: 19,
              },
              {
                step: '5.4',
                page_id: 34,
              },
              {
                step: '5.4',
                page_id: 26,
                can_resume: false,
                fail_redirect: {
                  page_id: 25,
                  can_goBack: true,
                },
              },
            ],
          },
          {
            step: 'success',
            pages: [{ page_id: 23 }, { page_id: 10 }],
          },
          { step: 'fail', pages: [{ page_id: 25 }] },
          { step: 'cancel-register', pages: [{ page_id: 37 }] },
        ],
      },
      error: 'null',
    };
    return new Observable(observer => observer.next(response));
  }

  override getCurrentState(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<getCurrentStateResponseDto>> {
    return this.http.post<ResponseDto<getCurrentStateResponseDto>>(
      environment.base_url + '/v1/onboarding/workflow/get-current-state',
      request
    );
  }

  override getCurrentWorkFlow(): Observable<ResponseDto<any>> {
    throw new Error('Method not implemented.');
  }

  override startKyc(
    request: StartKYCRequestDto
  ): Observable<ResponseDto<StartKYCResponseDto>> {
    return this.http.post<ResponseDto<StartKYCResponseDto>>(
      environment.base_url + '/v1/onboarding/start-kyc',
      request
    );
  }

  override getTermAndConsent(
    request: GetTermAndConsentRequestDto
  ): Observable<ResponseDto<GetTermAndConsentResponseDto>> {
    return this.http.post<ResponseDto<GetTermAndConsentResponseDto>>(
      environment.base_url + '/v1/onboarding/term-consent/get-term-consent',
      request
    );
  }

  override acceptTermAndConsent(
    request: AcceptTermAndConsentRequestDto
  ): Observable<ResponseDto<boolean | AcceptTermAndConsentResponseDto>> {
    return this.http.post<
      ResponseDto<boolean | AcceptTermAndConsentResponseDto>
    >(
      environment.base_url + '/v1/onboarding/term-consent/accept-term-consent',
      request
    );
  }

  override getLoanTypeList(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetLoanTypeListResponseDto>> {
    return this.http.post<ResponseDto<GetLoanTypeListResponseDto>>(
      environment.base_url + '/v1/onboarding/loan/get-loanlist',
      request
    );
  }

  override getLoanType(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/loan/get-loantype',
      request
    );
  }

  override setLoanType(
    request: setLoanTypeRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/loan/set-loantype',
      request
    );
  }

  override updateContact(
    request: ContactRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/contact/update',
      request
    );
  }

  override getContact(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/contact/get',
      request
    );
  }

  override getWorking(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<WorkingResponseDto>> {
    return this.http.post<ResponseDto<WorkingResponseDto>>(
      environment.base_url + '/v1/onboarding/working/get',
      request
    );
  }

  override updateWorking(
    request: UpdateWorkingRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/working/update',
      request
    );
  }

  override sendOTP(request: SendOTPRequestDto): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/contact/send-otp',
      request
    );
  }

  override confirmOTP(
    request: ConfirmOTPRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/contact/verify-otp',
      request
    );
  }

  override getAddress(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetAddressResponseDto[]>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/address/get',
      request
    );
  }

  override updateAddress(
    request: UpdateAddressRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/address/update',
      request
    );
  }

  override updateTypeAddress(
    request: updateTypeAddressRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/address/update-contact',
      request
    );
  }

  override getUploadFile(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/document/get',
      request
    );
  }

  override deleteFile(
    request: DeleteDocumentRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/document/del',
      request
    );
  }

  override uploadDocument(
    request: UploadDocumentRequestDto
  ): Observable<ResponseDto<any>> {
    const formData = new FormData();
    formData.append('txn_id', request.txn_id);
    formData.append('document_id', request.document_id);
    formData.append('group', request.group);
    formData.append('file', request.file);

    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/document/upload',
      formData
    );
  }

  override uploadOcrDocument(
    request: UploadOcrDocumentRequestDto
  ): Observable<ResponseDto<boolean>> {
    const formData = new FormData();
    formData.append('txn_id', request.txn_id);
    formData.append('type', request.type);
    formData.append('img', request.img);

    if (request.ocr_laser_id != null) {
      formData.append('ocr_laser_id', request.ocr_laser_id);
    }

    if (request.edit_laser_id != null) {
      formData.append('edit_laser_id', request.edit_laser_id);
    }

    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/document/upload-doc/ocr',
      formData
    );
  }

  override processDoc(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/document/process-doc',
      request
    );
  }

  override compareUserData(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean | CompareUserDataResponseDto>> {
    return this.http.post<ResponseDto<boolean | CompareUserDataResponseDto>>(
      environment.base_url + '/v1/onboarding/compare/user-data',
      request
    );
  }

  override getDocument(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetDocumentResponseDto>> {
    return this.http.post<ResponseDto<GetDocumentResponseDto>>(
      environment.base_url + '/v1/onboarding/identity/document/get-doc',
      request
    );
  }

  override updateDocument(
    request: UpdateDocumentRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/document/update-doc',
      request
    );
  }

  override verifyDocument(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/document/verify-doc',
      request
    );
  }

  override uploadSelfie(
    request: UploadSelfieRequestDto
  ): Observable<ResponseDto<boolean>> {
    const formData = new FormData();
    formData.append('txn_id', request.txn_id);
    formData.append('img', request.img);

    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/selfie/upload-selfie',
      formData
    );
  }

  override getSelfie(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetSelfieResponseDto>> {
    return this.http.post<ResponseDto<GetSelfieResponseDto>>(
      environment.base_url + '/v1/onboarding/identity/document/get-selfie',
      request
    );
  }

  override updateProcessing(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/identity/selfie/processing',
      request
    );
  }

  override updateCurrentStep(
    request: UpdateCurrentStepRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/update/current-step',
      request
    );
  }

  override getInfo(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<LoanInfoResponseDto>> {
    return this.http.post<ResponseDto<LoanInfoResponseDto>>(
      environment.base_url + '/v1/onboarding/get-info',
      request
    );
  }

  override ndidCancelVerify(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/ndid/cancel-verify',
      request
    );
  }

  override getProductList(
    request: getProductlistRequestDto
  ): Observable<ResponseDto<getProductlistResponseDto[]>> {
    return this.http.post<ResponseDto<getProductlistResponseDto[]>>(
      environment.base_url + '/v1/onboarding/loan/product/get-list',
      request
    );
  }

  override getProduct(
    request: GetProductRequestDto
  ): Observable<ResponseDto<GetProductResponseDto>> {
    return this.http.post<ResponseDto<GetProductResponseDto>>(
      environment.base_url + '/v1/onboarding/loan/product/get-product',
      request
    );
  }

  override setProduct(
    request: setProductRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/loan/product/set-product',
      request
    );
  }

  override getPersonalLoan(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetPersonalLoanResponseDto>> {
    return this.http.post<ResponseDto<GetPersonalLoanResponseDto>>(
      environment.base_url + '/v1/onboarding/loan/personal/get-personal',
      request
    );
  }

  override getNanoFinance(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetPersonalLoanResponseDto>> {
    return this.http.post<ResponseDto<GetPersonalLoanResponseDto>>(
      environment.base_url + '/v1/onboarding/loan/nano-finance/get-nano',
      request
    );
  }

  override closeKyc(
    request: OnBoardingTransactionRequestDto,
    idempotencyKey: string
  ): Observable<ResponseDto<CloseKycResponseDto | boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/close-kyc',
      request,
      {
        headers: {
          'idempotency-key': idempotencyKey,
        },
      }
    );
  }

  override ndidRequestData(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidRequestDataResponseDto>> {
    return this.http.post<ResponseDto<NdidRequestDataResponseDto>>(
      environment.base_url + '/v1/onboarding/ndid/verify-and-request-data',
      request
    );
  }

  override ndidGetConsent(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<string>> {
    return this.http.post<ResponseDto<string>>(
      environment.base_url + '/v1/onboarding/ndid/get-consent',
      request
    );
  }

  /**
   * Call when click button
   */
  override ndidCheckRequest(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidCheckRequestResponseDto>> {
    return this.http.post<ResponseDto<NdidCheckRequestResponseDto>>(
      environment.base_url + '/v1/onboarding/ndid/check-verify-idp',
      request
    );
  }
  /**
   * Call every 10 sec before ndidGetConsent
   */
  override ndidCheckStatus(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<NdidCheckRequestResponseDto>> {
    return this.http.post<ResponseDto<NdidCheckRequestResponseDto>>(
      environment.base_url + '/v1/onboarding/ndid/check-status',
      request
    );
  }

  override getProvince(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetProvinceResponseDto[]>> {
    return this.http.get<ResponseDto<GetProvinceResponseDto[]>>(
      environment.base_url + '/v1/data/dic/province',
      {
        params: { ...request },
      }
    );
  }

  override getDistrict(
    request: GetDistrictRequestDto
  ): Observable<ResponseDto<GetDistrictResponseDto[]>> {
    return this.http.get<ResponseDto<GetDistrictResponseDto[]>>(
      environment.base_url + '/v1/data/dic/district',
      {
        params: { ...request },
      }
    );
  }

  override getSubDistrict(
    request: GetSubDistrictRequestDto
  ): Observable<ResponseDto<GetSubDistrictResponseDto[]>> {
    return this.http.get<ResponseDto<GetSubDistrictResponseDto[]>>(
      environment.base_url + '/v1/data/dic/sub-district',
      {
        params: { ...request },
      }
    );
  }

  override getPostCode(
    request: GetSubDistrictRequestDto
  ): Observable<ResponseDto<GetPostCodeResponseDto[]>> {
    return this.http.get<ResponseDto<GetPostCodeResponseDto[]>>(
      environment.base_url + '/v1/data/dic/postcode',
      {
        params: { ...request },
      }
    );
  }

  override getHousingType(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetHousingTypeResponseDto[]>> {
    return this.http.get<ResponseDto<GetHousingTypeResponseDto[]>>(
      environment.base_url + '/v1/data/dic/housing-type',
      {
        params: { ...request },
      }
    );
  }

  override getOccupationGroup(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetOccupationGroupResponseDto[]>> {
    return this.http.get<ResponseDto<GetOccupationGroupResponseDto[]>>(
      environment.base_url + '/v1/data/dic/occupation-group',
      {
        params: { ...request },
      }
    );
  }
  override getOccupation(
    request: GetOccupationRequestDto
  ): Observable<ResponseDto<GetOccupationResponseDto[]>> {
    return this.http.get<ResponseDto<GetOccupationResponseDto[]>>(
      environment.base_url + '/v1/data/dic/occupation',
      {
        params: { ...request },
      }
    );
  }

  override confirmProduct(
    request: confirmProductRequestDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/loan/product/confirm-product',
      request
    );
  }

  override confirmPersonalLoan(
    request: confirmPersonalLoanRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/loan/personal/confirm-personal',
      request
    );
  }

  override confirmNanoFinance(
    request: confirmPersonalLoanRequestDto
  ): Observable<ResponseDto<boolean>> {
    return this.http.post<ResponseDto<boolean>>(
      environment.base_url + '/v1/onboarding/loan/nano-finance/confirm-nano',
      request
    );
  }

  override resumeState(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<getResumeStateResponseDto>> {
    return this.http.post<ResponseDto<getResumeStateResponseDto>>(
      environment.base_url + '/v1/onboarding/resume-state',
      request
    );
  }

  override confirmData(
    request: confirmDataRequestDto
  ): Observable<ResponseDto<confirmDataResponseDto>> {
    return this.http.post<ResponseDto<confirmDataResponseDto>>(
      environment.base_url + '/v1/onboarding/confirm-data',
      request
    );
  }

  override reject(request: OnBoardingTransactionRequestDto): Observable<any> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/reject',
      request
    );
  }

  override customerAccessFile(
    request: GetCustomerFileListDto
  ): Observable<ResponseDto<any>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/customer-access-file/list',
      request
    );
  }

  override customerDownloadFile(request: downloadFileDto) {
    return this.http.get(
      environment.base_url + '/v1/customer-access-file/download',
      {
        responseType: 'blob',
        params: { ...request },
      }
    );
  }
  override beginTxn(
    request: BeginTransactionRequestDto
  ): Observable<ResponseDto<BeginTransactionResponseDto>> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/begin-txn',
      request
    );
  }

  override verifyIdCardNumber(
    request: VerifyIdCardNumberRequestDto
  ): Observable<any> {
    return this.http.post<ResponseDto<any>>(
      environment.base_url + '/v1/onboarding/identity/verify-id-number',
      request
    );
  }

  override checkLimitPolicy(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<CheckLimitPolicyResponse>> {
    return this.http.post<ResponseDto<CheckLimitPolicyResponse>>(
      environment.base_url + '/v1/onboarding/loan/checkLimitPolicy',
      request
    );
  }

  override getTxn(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetTxnResponseDto>> {
    return this.http.post<ResponseDto<GetTxnResponseDto>>(
      environment.base_url + '/v1/onboarding/get-txn',
      request
    );
  }

  override getAutoApprove(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<GetAutoApproveResponse>> {
    return this.http.post<ResponseDto<GetAutoApproveResponse>>(
      environment.base_url + '/v1/onboarding/get-auto-approve',
      request
    );
  }

  override updatePersonalInfo(
    request: PersonalInfoUpdateRequestDto
  ): Observable<ResponseDto<PersonalInfoUpdateResponseDto>> {
    return this.http.post<ResponseDto<PersonalInfoUpdateResponseDto>>(
      environment.base_url + '/v1/onboarding/personal-info/update',
      request
    );
  }

  override getPersonalInfo(
    request: OnBoardingTransactionRequestDto
  ): Observable<ResponseDto<PersonalInfoUpdateResponseDto>> {
    return this.http.post<ResponseDto<PersonalInfoUpdateResponseDto>>(
      environment.base_url + '/v1/onboarding/personal-info/get',
      request
    );
  }
}
